import React from "react";
import "./404.css"
import {Grid,} from "@mui/material";

const PageNotFound = () => {
  
  return (
    <>
      <Grid
        continer
        xs={12}
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        className="body"
      >
        <h1 style={{display:"flex"}}>
          <span className="four">4</span>
          <span className="zero">0</span>
          <span className="four">4</span>
        </h1>
        <h2>Ooops..</h2>
        <h3>The Web Page not Available </h3>
       
      </Grid>
    </>
  );
};

export default PageNotFound;